import 'babel-polyfill';
import './is-touch-device';
import './focuspoint-helper';
import './banner-scroll-hide';
import './nav';
import './mobile-nav';
import './more-nav';
import './dialog';
import './hover-card';
import './bbox';
import './required-label';
import './tag';
import './svg-injector-helper';
import './swiper';

// bring in Salvattore
require('salvattore');

// filter-tags
if (document.querySelector('[data-filter-tags]')) {
    import(/* webpackChunkName: "filter-tags" */ './filter-tags').then();
}

// alert
if (document.querySelector('[data-alert]')) {
    import(/* webpackChunkName: "alert" */ './alert').then();
}

// custom-validity
if (document.querySelector('[data-custom-validity]')) {
    import(/* webpackChunkName: "custom-validity" */ './custom-validity').then();
}

// show-if
if (document.querySelector('[data-show-if]')) {
    import(/* webpackChunkName: "show-if" */ './show-if').then();
}

// membership-form
if (document.querySelector('[data-membership-form]')) {
    import(/* webpackChunkName: "membership-form" */ './membership-form').then();
}

// grant-membership-form
if (document.querySelector('[data-grant-membership-form]')) {
    import(/* webpackChunkName: "grant-membership-form" */ './grant-membership-form').then();
}

// donation-form
if (document.querySelector('[data-donation-form]')) {
    import(/* webpackChunkName: "donation-form" */ './donation-form').then();
}

// tooltip
if (document.querySelector('[data-tooltip]')) {
    import(/* webpackChunkName: "tooltip" */ './tooltip').then();
}

// calendar
if (document.querySelector('[data-calendar]')) {
    import(/* webpackChunkName: "calendar" */ './calendar').then();
}

// readmore
if (document.querySelector('[data-readmore]')) {
    import(/* webpackChunkName: "readmore" */ './readmore').then();
}

// background-video
if (document.querySelector('[data-background-video]')) {
    import(/* webpackChunkName: "background-video" */ './background-video').then();
}

// xmas-bkgnd
if (document.querySelector('.xmas-bkgnd-start')) {
    import(/* webpackChunkName: "background-video" */ './xmas-bkgnd').then();
}
